import isClipboardWebCustomFormatSupported from "./isClipboardWebCustomFormatSupported";
import isClipboardWritable from "./isClipboardWritable";

const isCopyAttachmentToClipboardEnabled = (): boolean => {
    return isClipboardWebCustomFormatSupported() && isClipboardWritable();
};

export default isCopyAttachmentToClipboardEnabled;
